import { useState, useEffect, useRef } from "react";

// ─── Seed Data ────────────────────────────────────────────────────────────────
const SEED_TRIPS = [
  { id: 1, vehicle: "TN43 AB 1234", vehicleType: "7 Seater", driver: "Ravi Kumar", customer: "Arjun Mehta", phone: "9876543210", pickup: "Kodai Road Station", drop: "Kodaikanal Lake", fromKm: 12400, toKm: 12435, amount: 1200, date: "2025-03-01", status: "completed", msgType: "whatsapp" },
  { id: 2, vehicle: "TN43 CD 5678", vehicleType: "4 Seater", driver: "Suresh Babu", customer: "Priya & Karthik", phone: "9988776655", pickup: "Kodai Road Bus Stand", drop: "Silver Cascade", fromKm: 8200, toKm: 8240, amount: 900, date: "2025-03-02", status: "completed", msgType: "sms" },
  { id: 3, vehicle: "TN43 EF 9012", vehicleType: "12 Seater", driver: "Murugan S", customer: "ABC Company Group", phone: "9123456789", pickup: "Kodai Road", drop: "Pillar Rocks", fromKm: 5600, toKm: 5660, amount: 3500, date: "2025-03-03", status: "completed", msgType: "whatsapp" },
  { id: 4, vehicle: "TN43 GH 3456", vehicleType: "25 Seater", driver: "Vijay D", customer: "Chennai School Trip", phone: "9000011111", pickup: "Kodai Road", drop: "Kodaikanal", fromKm: 22100, toKm: 22175, amount: 8000, date: "2025-03-04", status: "completed", msgType: "sms" },
  { id: 5, vehicle: "TN43 AB 1234", vehicleType: "7 Seater", driver: "Ravi Kumar", customer: "Sneha Reddy", phone: "9876501234", pickup: "Railway Station", drop: "Coaker's Walk", fromKm: 12435, toKm: 12475, amount: 1100, date: "2025-03-05", status: "completed", msgType: "whatsapp" },
  { id: 6, vehicle: "TN43 CD 5678", vehicleType: "4 Seater", driver: "Suresh Babu", customer: "Honeymoon Couple", phone: "9543210987", pickup: "Kodai Road", drop: "Bryant Park", fromKm: 8240, toKm: 8275, amount: 1500, date: "2025-03-06", status: "ongoing", msgType: "whatsapp" },
];

const DRIVERS = ["Ravi Kumar", "Suresh Babu", "Murugan S", "Vijay D", "Anand P"];
const VEHICLES = [
  { number: "TN43 AB 1234", type: "7 Seater" },
  { number: "TN43 CD 5678", type: "4 Seater" },
  { number: "TN43 EF 9012", type: "12 Seater" },
  { number: "TN43 GH 3456", type: "25 Seater" },
];

const PHONE_CONTACTS = [
  { name: "Arjun Mehta", phone: "9876543210" },
  { name: "Priya Sharma", phone: "9988776655" },
  { name: "Karthik Rajan", phone: "9123456789" },
  { name: "Sneha Reddy", phone: "9876501234" },
  { name: "Vijay Anand", phone: "9543210987" },
  { name: "Meena Kumari", phone: "9001122334" },
  { name: "Rahul Verma", phone: "9871234567" },
  { name: "Divya Nair", phone: "9765432100" },
  { name: "Lakshmi Devi", phone: "9444556677" },
  { name: "Bala Murugan", phone: "9600123456" },
  { name: "Anjali Singh", phone: "9822334455" },
  { name: "Mohan Kumar", phone: "9700011223" },
  { name: "Radha Krishnan", phone: "9933445566" },
  { name: "Tamil Selvan", phone: "9655443322" },
];

const C = {
  bg: "#F0F4FF", card: "#FFFFFF", primary: "#1D4ED8", primaryLight: "#EFF6FF",
  green: "#059669", greenLight: "#ECFDF5", orange: "#EA580C",
  purple: "#7C3AED", purpleLight: "#F5F3FF", sub: "#64748B",
  text: "#0F172A", border: "#E2E8F0", wa: "#25D366", waLight: "#F0FDF4",
};

const buildMsg = (trip) =>
  `Dear ${trip.customer},\n\nThank you for choosing *Maggi Cabs* 🚕\n\nTrip: ${trip.pickup} ➜ ${trip.drop}\nDistance: ${trip.toKm - trip.fromKm} km\nAmount: ₹${trip.amount}\n\n⭐ Google Review:\nhttps://maps.google.com/maggi-cabs\n\n📞 Book again: 9445876319\n\nMaggi Cabs Team`;

const sendWhatsApp = (phone, msg) => window.open(`https://wa.me/91${phone}?text=${encodeURIComponent(msg)}`, "_blank");
const sendSMS = (phone, msg) => window.open(`sms:${phone}?body=${encodeURIComponent(msg)}`, "_self");

// ─── Icons ────────────────────────────────────────────────────────────────────
const Ico = ({ d, size = 22, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);
const IC = {
  home: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10",
  add: ["M12 5v14", "M5 12h14"],
  list: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 000 4h6a2 2 0 000-4M9 5a2 2 0 012-2h2a2 2 0 012 2",
  users: ["M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2","M23 21v-2a4 4 0 00-3-3.87","M16 3.13a4 4 0 010 7.75"],
  msg: "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z",
  check: "M20 6L9 17l-5-5",
  close: ["M18 6L6 18","M6 6l12 12"],
  contact: ["M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2","M12 11a4 4 0 100-8 4 4 0 000 8z"],
  search: ["M11 17.25a6.25 6.25 0 110-12.5 6.25 6.25 0 010 12.5z","M16 16l4.5 4.5"],
  send: "M22 2L11 13 M22 2L15 22 8 13 2 9z",
  km: "M13 10V3L4 14h7v7l9-11h-7z",
  back: "M19 12H5 M12 19l-7-7 7-7",
};

// ─── UI Primitives ────────────────────────────────────────────────────────────
const Avatar = ({ name, size = 40, idx = 0 }) => {
  const palettes = [["#DBEAFE","#1D4ED8"],["#EDE9FE","#7C3AED"],["#DCFCE7","#059669"],["#FEF3C7","#D97706"],["#FFE4E6","#E11D48"]];
  const [bg, fg] = palettes[idx % palettes.length];
  return <div style={{ width: size, height: size, borderRadius: "50%", background: bg, color: fg, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: size * 0.38, flexShrink: 0 }}>{name?.[0]?.toUpperCase() || "?"}</div>;
};

const Badge = ({ status }) => {
  const m = { completed: ["#ECFDF5","#065F46","✓ Done"], ongoing: ["#FFF7ED","#9A3412","● Active"], pending: ["#FEF2F2","#991B1B","⏳ Pending"] };
  const [bg, fg, label] = m[status] || m.pending;
  return <span style={{ background: bg, color: fg, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{label}</span>;
};

const MsgBadge = ({ type }) => type === "whatsapp"
  ? <span style={{ background: C.waLight, color: C.wa, padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 700 }}>💬 WA</span>
  : <span style={{ background: "#F0F9FF", color: "#0369A1", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 700 }}>📱 SMS</span>;

const Toast = ({ msg }) => (
  <div style={{ position: "fixed", bottom: 90, left: "50%", transform: "translateX(-50%)", background: "#0F172A", color: "#fff", padding: "12px 22px", borderRadius: 30, fontSize: 13, fontWeight: 600, zIndex: 999, whiteSpace: "nowrap", boxShadow: "0 8px 24px rgba(0,0,0,0.25)", animation: "slideUp .3s ease" }}>
    ✅ {msg}
  </div>
);

const FieldLabel = ({ children }) => (
  <div style={{ fontSize: 11, fontWeight: 700, color: C.sub, marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>{children}</div>
);

const TextInput = ({ label, ...props }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <FieldLabel>{label}</FieldLabel>}
    <input {...props} style={{ width: "100%", padding: "13px 14px", borderRadius: 12, border: `1.5px solid ${C.border}`, fontSize: 15, color: C.text, background: "#fff", WebkitAppearance: "none", fontFamily: "inherit", ...props.style }} />
  </div>
);

const Dropdown = ({ label, options, ...props }) => (
  <div style={{ marginBottom: 14 }}>
    {label && <FieldLabel>{label}</FieldLabel>}
    <div style={{ position: "relative" }}>
      <select {...props} style={{ width: "100%", padding: "13px 36px 13px 14px", borderRadius: 12, border: `1.5px solid ${C.border}`, fontSize: 15, color: props.value ? C.text : C.sub, background: "#fff", WebkitAppearance: "none", appearance: "none", fontFamily: "inherit" }}>
        <option value="">Select…</option>
        {options.map(o => <option key={o.value || o} value={o.value || o}>{o.label || o}</option>)}
      </select>
      <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: C.sub }}>▾</span>
    </div>
  </div>
);

// ─── Contact Picker ───────────────────────────────────────────────────────────
function ContactPicker({ onSelect, onClose, multi = false, preSelected = [] }) {
  const [search, setSearch] = useState("");
  const [sel, setSel] = useState(preSelected.map ? preSelected : []);
  const filtered = PHONE_CONTACTS.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) || c.phone.includes(search)
  );

  const toggle = (c) => {
    if (!multi) { onSelect(c); return; }
    setSel(prev => prev.find(p => p.phone === c.phone) ? prev.filter(p => p.phone !== c.phone) : [...prev, c]);
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 300, display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
      <div style={{ background: "#fff", borderRadius: "22px 22px 0 0", maxHeight: "88vh", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "center", padding: "12px 0 4px" }}>
          <div style={{ width: 36, height: 4, borderRadius: 2, background: "#CBD5E1" }} />
        </div>
        <div style={{ padding: "4px 18px 12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ fontWeight: 800, fontSize: 18, color: C.text }}>📱 Phone Contacts</div>
          <button onClick={onClose} style={{ background: "#F1F5F9", border: "none", borderRadius: "50%", width: 34, height: 34, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Ico d={IC.close} size={16} color={C.sub} />
          </button>
        </div>
        <div style={{ padding: "0 18px 12px" }}>
          <div style={{ position: "relative" }}>
            <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: C.sub, pointerEvents: "none" }}>🔍</span>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search name or number…"
              style={{ width: "100%", padding: "11px 14px 11px 36px", borderRadius: 12, border: `1.5px solid ${C.border}`, fontSize: 14, color: C.text, background: "#F8FAFC", fontFamily: "inherit" }} />
          </div>
        </div>
        <div style={{ overflowY: "auto", flex: 1, padding: "0 18px" }}>
          {filtered.map((c, i) => {
            const isSel = multi && sel.find(s => s.phone === c.phone);
            return (
              <div key={c.phone} onClick={() => toggle(c)} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 0", borderBottom: `1px solid ${C.border}`, cursor: "pointer", background: isSel ? "#EFF6FF" : "#fff", margin: "0 -4px", padding: "12px 4px", borderRadius: 8 }}>
                <Avatar name={c.name} size={42} idx={i} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 15, color: C.text }}>{c.name}</div>
                  <div style={{ fontSize: 13, color: C.sub }}>{c.phone}</div>
                </div>
                {multi && (
                  <div style={{ width: 24, height: 24, borderRadius: 7, border: `2px solid ${isSel ? C.primary : C.border}`, background: isSel ? C.primary : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    {isSel && <Ico d={IC.check} size={13} color="#fff" />}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {multi && (
          <div style={{ padding: 16, borderTop: `1px solid ${C.border}` }}>
            <button onClick={() => onSelect(sel)} disabled={sel.length === 0}
              style={{ width: "100%", padding: 15, borderRadius: 14, border: "none", background: sel.length > 0 ? C.primary : "#CBD5E1", color: "#fff", fontWeight: 800, fontSize: 16, fontFamily: "inherit" }}>
              Add {sel.length > 0 ? `${sel.length} Contact${sel.length > 1 ? "s" : ""}` : "Contacts"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Bottom Nav ───────────────────────────────────────────────────────────────
function BottomNav({ page, setPage }) {
  const tabs = [
    { id: "dashboard", icon: IC.home, label: "Home" },
    { id: "trips", icon: IC.list, label: "Trips" },
    { id: "log", icon: IC.add, label: "" },
    { id: "customers", icon: IC.users, label: "People" },
    { id: "bulk", icon: IC.msg, label: "Message" },
  ];
  return (
    <nav style={{ position: "fixed", bottom: 0, left: 0, right: 0, maxWidth: 430, margin: "0 auto", background: "#fff", borderTop: `1px solid ${C.border}`, display: "flex", zIndex: 100, paddingBottom: 4 }}>
      {tabs.map(t => {
        const active = page === t.id;
        const isCenter = t.id === "log";
        return (
          <button key={t.id} onClick={() => setPage(t.id)}
            style={{ flex: 1, border: "none", background: "none", padding: isCenter ? 0 : "10px 0 6px", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, cursor: "pointer", WebkitTapHighlightColor: "transparent" }}>
            {isCenter ? (
              <div style={{ width: 54, height: 54, borderRadius: "50%", background: C.primary, display: "flex", alignItems: "center", justifyContent: "center", marginTop: -22, boxShadow: "0 4px 18px rgba(29,78,216,0.45)" }}>
                <Ico d={IC.add} size={28} color="#fff" />
              </div>
            ) : (
              <>
                <Ico d={t.icon} size={22} color={active ? C.primary : "#94A3B8"} />
                <span style={{ fontSize: 10, fontWeight: active ? 700 : 500, color: active ? C.primary : "#94A3B8" }}>{t.label}</span>
                {active && <div style={{ position: "absolute", top: 0, width: 20, height: 3, background: C.primary, borderRadius: "0 0 4px 4px" }} />}
              </>
            )}
          </button>
        );
      })}
    </nav>
  );
}

// ─── App ──────────────────────────────────────────────────────────────────────
export default function MaggiCabs() {
  const [page, setPage] = useState("dashboard");
  const [trips, setTrips] = useState(SEED_TRIPS);
  const [toast, setToast] = useState(null);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2800); };

  const customers = Object.values(trips.reduce((acc, t) => {
    if (!acc[t.phone]) acc[t.phone] = { name: t.customer, phone: t.phone, trips: 0, spent: 0 };
    acc[t.phone].trips++; acc[t.phone].spent += t.amount;
    return acc;
  }, {}));

  const props = { trips, setTrips, showToast, customers };

  return (
    <div style={{ maxWidth: 430, margin: "0 auto", minHeight: "100vh", background: C.bg, fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", position: "relative", overflowX: "hidden" }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; -webkit-tap-highlight-color: transparent; }
        @keyframes slideUp { from { transform: translate(-50%,20px); opacity:0; } to { transform: translate(-50%,0); opacity:1; } }
        @keyframes fadeIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
        @keyframes sheetUp { from { transform:translateY(100%); } to { transform:translateY(0); } }
        input, select, textarea, button { -webkit-appearance:none; outline:none; font-family:inherit; }
        ::-webkit-scrollbar { display:none; }
      `}</style>
      <div style={{ paddingBottom: 80, animation: "fadeIn .3s ease" }} key={page}>
        {page === "dashboard" && <Dashboard {...props} />}
        {page === "log" && <LogTrip {...props} />}
        {page === "trips" && <AllTrips {...props} />}
        {page === "customers" && <CustomersPage {...props} />}
        {page === "bulk" && <BulkMsg {...props} />}
      </div>
      <BottomNav page={page} setPage={setPage} />
      {toast && <Toast msg={toast} />}
    </div>
  );
}

// ─── Shared Trip Card ─────────────────────────────────────────────────────────
function TripCard({ trip: t, onComplete }) {
  return (
    <div style={{ background: "#fff", borderRadius: 18, padding: "16px", marginBottom: 10, boxShadow: "0 2px 10px rgba(0,0,0,0.06)", border: `1px solid ${C.border}` }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 15, color: C.text }}>{t.customer}</div>
          <div style={{ fontSize: 12, color: C.sub, marginTop: 2 }}>{t.driver} · {t.vehicleType}</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end" }}>
          <Badge status={t.status} /><MsgBadge type={t.msgType} />
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
        <span style={{ fontSize: 12, background: "#F8FAFC", padding: "4px 10px", borderRadius: 8, color: C.sub, fontWeight: 600 }}>{t.pickup}</span>
        <span style={{ color: C.sub }}>→</span>
        <span style={{ fontSize: 12, background: "#F8FAFC", padding: "4px 10px", borderRadius: 8, color: C.sub, fontWeight: 600 }}>{t.drop}</span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: 14 }}>
          <span style={{ fontSize: 13, color: C.purple, fontWeight: 700 }}>📍 {t.toKm - t.fromKm} km</span>
          <span style={{ fontSize: 13, color: C.green, fontWeight: 700 }}>₹{t.amount.toLocaleString()}</span>
        </div>
        <span style={{ fontSize: 11, color: C.sub }}>{t.date}</span>
      </div>
      {onComplete && t.status === "ongoing" && (
        <button onClick={() => onComplete(t.id)} style={{ width: "100%", marginTop: 10, padding: 11, borderRadius: 10, border: "none", background: C.greenLight, color: C.green, fontWeight: 700, fontSize: 14 }}>
          ✅ Mark Complete
        </button>
      )}
    </div>
  );
}

// ─── Dashboard ────────────────────────────────────────────────────────────────
function Dashboard({ trips, customers }) {
  const totalKm = trips.reduce((s, t) => s + (t.toKm - t.fromKm), 0);
  const totalRev = trips.reduce((s, t) => s + t.amount, 0);
  const ongoing = trips.filter(t => t.status === "ongoing");

  return (
    <div>
      <div style={{ background: "linear-gradient(135deg,#0F172A 0%,#1E40AF 100%)", padding: "52px 20px 32px", borderRadius: "0 0 28px 28px" }}>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>Welcome back 👋</div>
        <div style={{ color: "#fff", fontWeight: 900, fontSize: 26, marginBottom: 2 }}>Maggi Cabs</div>
        <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 13, marginBottom: 24 }}>Kodai Road – Kodaikanal</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
          {[["🚕", trips.length, "Trips"],["📍", `${totalKm.toLocaleString()}`, "KM"],["💰", `₹${(totalRev/1000).toFixed(1)}K`, "Revenue"]].map(([ic, v, l]) => (
            <div key={l} style={{ background: "rgba(255,255,255,0.1)", borderRadius: 14, padding: "14px 10px", backdropFilter: "blur(8px)" }}>
              <div style={{ fontSize: 22, marginBottom: 4 }}>{ic}</div>
              <div style={{ color: "#fff", fontWeight: 800, fontSize: 20 }}>{v}</div>
              <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 11 }}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: "20px 16px" }}>
        {ongoing.length > 0 && (
          <div style={{ background: "#FFF7ED", borderRadius: 14, padding: "14px 16px", marginBottom: 16, border: "1px solid #FED7AA", display: "flex", gap: 12, alignItems: "center" }}>
            <span style={{ fontSize: 24 }}>🚗</span>
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: "#9A3412" }}>{ongoing.length} Active Trip{ongoing.length > 1 ? "s" : ""}</div>
              <div style={{ fontSize: 12, color: "#C2410C" }}>{ongoing.map(t => t.driver.split(" ")[0]).join(", ")} on road</div>
            </div>
          </div>
        )}

        <div style={{ fontWeight: 800, fontSize: 16, color: C.text, marginBottom: 12 }}>Drivers</div>
        <div style={{ display: "flex", gap: 10, overflowX: "auto", paddingBottom: 6, marginBottom: 20 }}>
          {DRIVERS.map((d, i) => {
            const active = trips.find(t => t.driver === d && t.status === "ongoing");
            const cnt = trips.filter(t => t.driver === d).length;
            return (
              <div key={d} style={{ flexShrink: 0, background: "#fff", borderRadius: 16, padding: "14px 16px", width: 110, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", border: `1px solid ${active ? "#FED7AA" : C.border}` }}>
                <Avatar name={d} size={36} idx={i} />
                <div style={{ marginTop: 8, fontWeight: 700, fontSize: 13, color: C.text }}>{d.split(" ")[0]}</div>
                <div style={{ fontSize: 11, color: C.sub }}>{cnt} trips</div>
                <div style={{ fontSize: 11, fontWeight: 700, color: active ? "#EA580C" : C.green, marginTop: 4 }}>
                  {active ? "● On Trip" : "● Free"}
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ fontWeight: 800, fontSize: 16, color: C.text, marginBottom: 12 }}>Recent Trips</div>
        {[...trips].reverse().slice(0, 4).map(t => <TripCard key={t.id} trip={t} />)}
      </div>
    </div>
  );
}

// ─── Log Trip ─────────────────────────────────────────────────────────────────
function LogTrip({ trips, setTrips, showToast }) {
  const blank = { vehicle: "", vehicleType: "", driver: "", customer: "", phone: "", pickup: "", drop: "", fromKm: "", toKm: "", amount: "", date: new Date().toISOString().split("T")[0], status: "completed", msgType: "whatsapp" };
  const [f, setF] = useState(blank);
  const [showPicker, setShowPicker] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const dist = f.toKm && f.fromKm ? Math.max(0, Number(f.toKm) - Number(f.fromKm)) : 0;

  const valid = () => ["vehicle","driver","customer","phone","pickup","drop","fromKm","toKm","amount"].every(k => String(f[k]).trim());

  const submit = () => {
    const trip = { ...f, id: Date.now(), fromKm: +f.fromKm, toKm: +f.toKm, amount: +f.amount };
    setTrips(p => [...p, trip]);
    const msg = buildMsg(trip);
    if (f.msgType === "whatsapp") sendWhatsApp(f.phone, msg);
    else sendSMS(f.phone, msg);
    setF(blank);
    setShowConfirm(false);
    showToast(`Trip logged! ${f.msgType === "whatsapp" ? "WhatsApp" : "SMS"} sent to ${f.customer}`);
  };

  return (
    <div>
      <div style={{ background: "linear-gradient(135deg,#0F172A 0%,#1E3A8A 100%)", padding: "52px 20px 24px" }}>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>Driver Portal</div>
        <div style={{ color: "#fff", fontWeight: 900, fontSize: 24 }}>Log New Trip</div>
      </div>

      <div style={{ padding: "18px 16px" }}>
        {/* Vehicle & Driver */}
        <div style={{ background: "#fff", borderRadius: 18, padding: 18, marginBottom: 14, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 14 }}>🚕 Vehicle & Driver</div>
          <Dropdown label="Vehicle" value={f.vehicle} onChange={e => { const v = VEHICLES.find(x => x.number === e.target.value); set("vehicle", e.target.value); set("vehicleType", v?.type || ""); }}
            options={VEHICLES.map(v => ({ value: v.number, label: `${v.number} · ${v.type}` }))} />
          <Dropdown label="Driver" value={f.driver} onChange={e => set("driver", e.target.value)} options={DRIVERS.map(d => ({ value: d, label: d }))} />
        </div>

        {/* Customer */}
        <div style={{ background: "#fff", borderRadius: 18, padding: 18, marginBottom: 14, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: C.text }}>👤 Customer</div>
            <button onClick={() => setShowPicker(true)} style={{ display: "flex", alignItems: "center", gap: 6, background: C.primaryLight, color: C.primary, border: "none", borderRadius: 20, padding: "7px 14px", fontWeight: 700, fontSize: 13 }}>
              <Ico d={IC.contact} size={15} color={C.primary} /> Pick Contact
            </button>
          </div>
          <TextInput label="Name" value={f.customer} onChange={e => set("customer", e.target.value)} placeholder="Customer full name" />
          <FieldLabel>Phone Number</FieldLabel>
          <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
            <input value={f.phone} onChange={e => set("phone", e.target.value)} placeholder="10-digit number" type="tel"
              style={{ flex: 1, padding: "13px 14px", borderRadius: 12, border: `1.5px solid ${C.border}`, fontSize: 15, color: C.text, fontFamily: "inherit" }} />
            <button onClick={() => setShowPicker(true)} style={{ width: 48, height: 48, borderRadius: 12, background: C.primaryLight, border: "none", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Ico d={IC.contact} size={20} color={C.primary} />
            </button>
          </div>
        </div>

        {/* Route */}
        <div style={{ background: "#fff", borderRadius: 18, padding: 18, marginBottom: 14, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 14 }}>📍 Route</div>
          <TextInput label="Pickup" value={f.pickup} onChange={e => set("pickup", e.target.value)} placeholder="e.g. Kodai Road Station" />
          <TextInput label="Drop" value={f.drop} onChange={e => set("drop", e.target.value)} placeholder="e.g. Kodaikanal Lake" />
        </div>

        {/* KM & Amount */}
        <div style={{ background: "#fff", borderRadius: 18, padding: 18, marginBottom: 14, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 14 }}>🔢 Details</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <TextInput label="From KM" value={f.fromKm} onChange={e => set("fromKm", e.target.value)} placeholder="Start" type="number" />
            <TextInput label="To KM" value={f.toKm} onChange={e => set("toKm", e.target.value)} placeholder="End" type="number" />
          </div>
          {dist > 0 && (
            <div style={{ background: C.purpleLight, borderRadius: 10, padding: "10px 14px", marginBottom: 14, display: "flex", gap: 8, alignItems: "center" }}>
              <Ico d={IC.km} size={18} color={C.purple} />
              <span style={{ fontWeight: 700, color: C.purple, fontSize: 14 }}>Distance: {dist} km</span>
            </div>
          )}
          <TextInput label="Amount (₹)" value={f.amount} onChange={e => set("amount", e.target.value)} placeholder="Trip fare" type="number" />
          <TextInput label="Date" value={f.date} onChange={e => set("date", e.target.value)} type="date" />
          <Dropdown label="Status" value={f.status} onChange={e => set("status", e.target.value)}
            options={[{ value: "completed", label: "✓ Completed" }, { value: "ongoing", label: "● Ongoing" }]} />
        </div>

        {/* Message type */}
        <div style={{ background: "#fff", borderRadius: 18, padding: 18, marginBottom: 14, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 4 }}>📨 Send Thank-You Via</div>
          <div style={{ fontSize: 12, color: C.sub, marginBottom: 14 }}>Choose how to send the thank-you message to customer</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            {[{ t: "whatsapp", icon: "💬", label: "WhatsApp", color: C.wa, bg: C.waLight },
              { t: "sms", icon: "📱", label: "SMS", color: "#0369A1", bg: "#F0F9FF" }].map(o => (
              <button key={o.t} onClick={() => set("msgType", o.t)} style={{
                padding: "16px 10px", borderRadius: 14, border: `2px solid ${f.msgType === o.t ? o.color : C.border}`,
                background: f.msgType === o.t ? o.bg : "#fff", display: "flex", flexDirection: "column", alignItems: "center", gap: 5, cursor: "pointer"
              }}>
                <span style={{ fontSize: 30 }}>{o.icon}</span>
                <span style={{ fontWeight: 700, fontSize: 14, color: f.msgType === o.t ? o.color : C.sub }}>{o.label}</span>
                {f.msgType === o.t && <span style={{ fontSize: 11, color: o.color, fontWeight: 700 }}>✓ Selected</span>}
              </button>
            ))}
          </div>
        </div>

        {/* Message preview */}
        {f.customer && (
          <div style={{ background: "#0F172A", borderRadius: 18, padding: 18, marginBottom: 18 }}>
            <div style={{ color: "#F59E0B", fontWeight: 700, fontSize: 13, marginBottom: 10 }}>
              {f.msgType === "whatsapp" ? "💬 WhatsApp Preview" : "📱 SMS Preview"}
            </div>
            <div style={{ background: "rgba(255,255,255,0.07)", borderRadius: 12, padding: 14, fontSize: 13, color: "#E2E8F0", lineHeight: 1.8, whiteSpace: "pre-wrap" }}>
              {buildMsg({ ...f, fromKm: +f.fromKm || 0, toKm: +f.toKm || 0 })}
            </div>
          </div>
        )}

        <button onClick={() => valid() ? setShowConfirm(true) : showToast("Please fill all required fields")}
          style={{ width: "100%", padding: 17, borderRadius: 16, border: "none", background: C.primary, color: "#fff", fontWeight: 800, fontSize: 17, boxShadow: "0 4px 18px rgba(29,78,216,0.4)" }}>
          Log Trip & Send {f.msgType === "whatsapp" ? "WhatsApp 💬" : "SMS 📱"}
        </button>
      </div>

      {showPicker && <ContactPicker onSelect={c => { set("customer", c.name); set("phone", c.phone); setShowPicker(false); }} onClose={() => setShowPicker(false)} />}

      {showConfirm && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 200, display: "flex", alignItems: "flex-end" }}>
          <div style={{ background: "#fff", borderRadius: "22px 22px 0 0", width: "100%", padding: 24, animation: "sheetUp .3s ease" }}>
            <div style={{ fontWeight: 800, fontSize: 18, color: C.text, marginBottom: 4 }}>Confirm Trip</div>
            <div style={{ fontSize: 13, color: C.sub, marginBottom: 18 }}>
              A thank-you {f.msgType === "whatsapp" ? "WhatsApp" : "SMS"} will be sent to <b>{f.customer}</b>
            </div>
            <div style={{ background: C.bg, borderRadius: 14, padding: 16, marginBottom: 20, lineHeight: 2, fontSize: 14, color: C.text }}>
              🚕 {f.vehicle} · {f.vehicleType}<br/>
              👤 {f.customer} · {f.phone}<br/>
              📍 {f.pickup} → {f.drop}<br/>
              🔢 {dist} km · ₹{f.amount}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <button onClick={() => setShowConfirm(false)} style={{ padding: 15, borderRadius: 14, border: `1.5px solid ${C.border}`, background: "#fff", fontWeight: 700, color: C.sub, fontSize: 15 }}>Cancel</button>
              <button onClick={submit} style={{ padding: 15, borderRadius: 14, border: "none", background: C.primary, color: "#fff", fontWeight: 800, fontSize: 15 }}>Confirm ✓</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── All Trips ────────────────────────────────────────────────────────────────
function AllTrips({ trips, setTrips, showToast }) {
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  const list = [...trips].reverse().filter(t =>
    (filter === "all" || t.status === filter) &&
    (t.customer.toLowerCase().includes(search.toLowerCase()) || t.driver.toLowerCase().includes(search.toLowerCase()))
  );

  const complete = (id) => { setTrips(p => p.map(t => t.id === id ? { ...t, status: "completed" } : t)); showToast("Trip completed!"); };

  return (
    <div>
      <div style={{ background: "linear-gradient(135deg,#1E3A8A 0%,#2563EB 100%)", padding: "52px 20px 24px" }}>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>Records</div>
        <div style={{ color: "#fff", fontWeight: 900, fontSize: 24 }}>All Trips</div>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>{trips.length} total trips logged</div>
      </div>
      <div style={{ padding: "16px 16px" }}>
        <div style={{ position: "relative", marginBottom: 12 }}>
          <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>🔍</span>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search customer or driver…"
            style={{ width: "100%", padding: "13px 14px 13px 40px", borderRadius: 14, border: `1.5px solid ${C.border}`, fontSize: 14, background: "#fff", fontFamily: "inherit" }} />
        </div>
        <div style={{ display: "flex", gap: 8, marginBottom: 16, overflowX: "auto" }}>
          {[["all", `All (${trips.length})`], ["completed", `Done (${trips.filter(t=>t.status==="completed").length})`], ["ongoing", `Active (${trips.filter(t=>t.status==="ongoing").length})`]].map(([v, l]) => (
            <button key={v} onClick={() => setFilter(v)} style={{ flexShrink: 0, padding: "8px 16px", borderRadius: 20, border: `1.5px solid ${filter === v ? C.primary : C.border}`, background: filter === v ? C.primaryLight : "#fff", color: filter === v ? C.primary : C.sub, fontWeight: 700, fontSize: 13 }}>{l}</button>
          ))}
        </div>
        {list.map(t => <TripCard key={t.id} trip={t} onComplete={complete} />)}
        {!list.length && <div style={{ textAlign: "center", padding: 40, color: C.sub }}>No trips found</div>}
      </div>
    </div>
  );
}

// ─── Customers ────────────────────────────────────────────────────────────────
function CustomersPage({ customers, trips, showToast }) {
  const [sel, setSel] = useState(null);
  const ctTrips = (phone) => trips.filter(t => t.phone === phone).reverse();

  return (
    <div>
      <div style={{ background: "linear-gradient(135deg,#4C1D95 0%,#7C3AED 100%)", padding: "52px 20px 24px" }}>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>Database</div>
        <div style={{ color: "#fff", fontWeight: 900, fontSize: 24 }}>Customers</div>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>{customers.length} registered</div>
      </div>
      <div style={{ padding: "16px 16px" }}>
        {customers.map((c, i) => (
          <div key={c.phone} onClick={() => setSel(c)}
            style={{ background: "#fff", borderRadius: 18, padding: "16px", marginBottom: 10, display: "flex", alignItems: "center", gap: 14, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", border: `1px solid ${C.border}`, cursor: "pointer" }}>
            <Avatar name={c.name} size={48} idx={i} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: C.text }}>{c.name}</div>
              <div style={{ fontSize: 12, color: C.sub }}>{c.phone}</div>
              <div style={{ fontSize: 12, color: C.sub, marginTop: 2 }}>{c.trips} trip{c.trips > 1 ? "s" : ""}</div>
            </div>
            <div style={{ fontWeight: 800, fontSize: 17, color: C.green }}>₹{c.spent.toLocaleString()}</div>
          </div>
        ))}
      </div>

      {sel && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 200, display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
          <div style={{ background: "#fff", borderRadius: "22px 22px 0 0", maxHeight: "88vh", display: "flex", flexDirection: "column", animation: "sheetUp .3s ease" }}>
            <div style={{ display: "flex", justifyContent: "center", padding: "12px 0 4px" }}>
              <div style={{ width: 36, height: 4, borderRadius: 2, background: "#CBD5E1" }} />
            </div>
            <div style={{ padding: "4px 20px 14px", display: "flex", gap: 14, alignItems: "center" }}>
              <Avatar name={sel.name} size={52} idx={customers.findIndex(c => c.phone === sel.phone)} />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 800, fontSize: 18, color: C.text }}>{sel.name}</div>
                <div style={{ fontSize: 14, color: C.sub }}>{sel.phone}</div>
              </div>
              <button onClick={() => setSel(null)} style={{ background: "#F1F5F9", border: "none", borderRadius: "50%", width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Ico d={IC.close} size={16} color={C.sub} />
              </button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, padding: "0 20px 16px" }}>
              <div style={{ background: C.primaryLight, borderRadius: 14, padding: 14, textAlign: "center" }}>
                <div style={{ fontSize: 26, fontWeight: 900, color: C.primary }}>{sel.trips}</div>
                <div style={{ fontSize: 12, color: C.sub }}>Trips</div>
              </div>
              <div style={{ background: C.greenLight, borderRadius: 14, padding: 14, textAlign: "center" }}>
                <div style={{ fontSize: 26, fontWeight: 900, color: C.green }}>₹{sel.spent.toLocaleString()}</div>
                <div style={{ fontSize: 12, color: C.sub }}>Spent</div>
              </div>
            </div>
            <div style={{ padding: "0 20px", fontWeight: 700, fontSize: 14, color: C.text, marginBottom: 10 }}>Trip History</div>
            <div style={{ overflowY: "auto", padding: "0 20px 10px", flex: 1 }}>
              {ctTrips(sel.phone).map(t => (
                <div key={t.id} style={{ borderBottom: `1px solid ${C.border}`, padding: "12px 0" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14, color: C.text }}>{t.pickup} → {t.drop}</div>
                      <div style={{ fontSize: 12, color: C.sub, marginTop: 2 }}>{t.date} · {t.driver} · {t.toKm - t.fromKm} km</div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontWeight: 700, color: C.green }}>₹{t.amount}</div>
                      <MsgBadge type={t.msgType} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, padding: "12px 20px 24px" }}>
              <button onClick={() => { sendWhatsApp(sel.phone, `Hi ${sel.name}! Book your next Kodaikanal trip with Maggi Cabs 🚕\n📞 9445876319`); showToast("WhatsApp opened!"); }}
                style={{ padding: 14, borderRadius: 14, border: "none", background: C.waLight, color: C.wa, fontWeight: 700, fontSize: 14 }}>💬 WhatsApp</button>
              <button onClick={() => { sendSMS(sel.phone, `Hi ${sel.name}! Book your next Kodaikanal trip with Maggi Cabs. Call: 9445876319`); showToast("SMS opened!"); }}
                style={{ padding: 14, borderRadius: 14, border: "none", background: "#F0F9FF", color: "#0369A1", fontWeight: 700, fontSize: 14 }}>📱 SMS</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Bulk Messaging ───────────────────────────────────────────────────────────
function BulkMsg({ customers, showToast }) {
  const [step, setStep] = useState(1);
  const [msg, setMsg] = useState("Happy Pongal from Maggi Cabs! 🌾\nBook your Kodaikanal trip today.\n📞 Call: 9445876319");
  const [msgType, setMsgType] = useState("whatsapp");
  const [recipients, setRecipients] = useState([]);
  const [showPicker, setShowPicker] = useState(false);
  const [log, setLog] = useState([]);

  const FESTIVALS = [
    { label: "🌾 Pongal", msg: "Happy Pongal from Maggi Cabs! 🌾\nBook your Kodaikanal trip today.\n📞 9445876319" },
    { label: "🪔 Diwali", msg: "Happy Diwali! 🪔\nCelebrate with a Kodaikanal trip.\n📞 9445876319" },
    { label: "🎄 Christmas", msg: "Merry Christmas! 🎄\nMagical Kodaikanal trip awaits!\n📞 9445876319" },
    { label: "🎉 New Year", msg: "Happy New Year! 🎆\nStart 2025 with Maggi Cabs.\n📞 9445876319" },
    { label: "☀️ Summer", msg: "Beat the heat! ☀️\nCool off at Kodaikanal.\n📞 9445876319" },
  ];

  const addPicked = (contacts) => {
    setRecipients(prev => {
      const ex = new Set(prev.map(c => c.phone));
      return [...prev, ...contacts.filter(c => !ex.has(c.phone))];
    });
    setShowPicker(false);
  };

  const addAll = () => setRecipients(customers.map(c => ({ name: c.name, phone: c.phone })));
  const remove = (phone) => setRecipients(p => p.filter(c => c.phone !== phone));

  const send = () => {
    if (!recipients.length) { showToast("Add recipients first"); return; }
    if (recipients.length > 0) {
      if (msgType === "whatsapp") sendWhatsApp(recipients[0].phone, msg);
      else sendSMS(recipients[0].phone, msg);
    }
    setLog(p => [{ id: Date.now(), count: recipients.length, preview: msg.slice(0, 50), type: msgType, time: new Date().toLocaleTimeString() }, ...p]);
    showToast(`Sent to ${recipients.length} customer${recipients.length > 1 ? "s" : ""}!`);
    setRecipients([]);
    setStep(1);
  };

  return (
    <div>
      <div style={{ background: "linear-gradient(135deg,#065F46 0%,#059669 100%)", padding: "52px 20px 24px" }}>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>Marketing</div>
        <div style={{ color: "#fff", fontWeight: 900, fontSize: 24 }}>Bulk Message</div>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>{customers.length} customers available</div>
      </div>

      <div style={{ padding: "16px 16px" }}>
        {/* Step indicator */}
        <div style={{ display: "flex", background: "#fff", borderRadius: 14, padding: 4, marginBottom: 18, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          {[["1","Message"],["2","Recipients"],["3","Send"]].map(([n, l]) => (
            <button key={n} onClick={() => setStep(+n)} style={{ flex: 1, padding: "11px 4px", borderRadius: 10, border: "none", background: step === +n ? C.primary : "transparent", color: step === +n ? "#fff" : C.sub, fontWeight: 700, fontSize: 13 }}>
              {n}. {l}
            </button>
          ))}
        </div>

        {/* Step 1 */}
        {step === 1 && (
          <div style={{ animation: "fadeIn .2s ease" }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 10 }}>Festival Templates</div>
            <div style={{ display: "flex", gap: 8, overflowX: "auto", paddingBottom: 6, marginBottom: 16 }}>
              {FESTIVALS.map(f => (
                <button key={f.label} onClick={() => setMsg(f.msg)} style={{ flexShrink: 0, padding: "9px 14px", borderRadius: 22, border: `1.5px solid ${C.border}`, background: "#fff", color: C.text, fontWeight: 600, fontSize: 13 }}>{f.label}</button>
              ))}
            </div>
            <div style={{ background: "#fff", borderRadius: 18, padding: 18, marginBottom: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
              <FieldLabel>Message Text</FieldLabel>
              <textarea value={msg} onChange={e => setMsg(e.target.value)} rows={5}
                style={{ width: "100%", padding: 14, borderRadius: 12, border: `1.5px solid ${C.border}`, fontSize: 14, lineHeight: 1.8, resize: "none", color: C.text, background: "#FAFAFA", fontFamily: "inherit" }} />
              <div style={{ fontSize: 11, color: C.sub, marginTop: 6 }}>{msg.length} characters</div>
            </div>
            <div style={{ background: "#fff", borderRadius: 18, padding: 18, marginBottom: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 12 }}>Send Via</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                {[{ t: "whatsapp", icon: "💬", label: "WhatsApp", color: C.wa, bg: C.waLight },
                  { t: "sms", icon: "📱", label: "SMS", color: "#0369A1", bg: "#F0F9FF" }].map(o => (
                  <button key={o.t} onClick={() => setMsgType(o.t)} style={{ padding: "16px 10px", borderRadius: 14, border: `2px solid ${msgType === o.t ? o.color : C.border}`, background: msgType === o.t ? o.bg : "#fff", display: "flex", flexDirection: "column", alignItems: "center", gap: 5, cursor: "pointer" }}>
                    <span style={{ fontSize: 28 }}>{o.icon}</span>
                    <span style={{ fontWeight: 700, fontSize: 14, color: msgType === o.t ? o.color : C.sub }}>{o.label}</span>
                    {msgType === o.t && <span style={{ fontSize: 11, color: o.color, fontWeight: 700 }}>✓ Selected</span>}
                  </button>
                ))}
              </div>
            </div>
            <button onClick={() => setStep(2)} style={{ width: "100%", padding: 16, borderRadius: 16, border: "none", background: C.primary, color: "#fff", fontWeight: 800, fontSize: 16 }}>
              Next: Recipients →
            </button>
          </div>
        )}

        {/* Step 2 */}
        {step === 2 && (
          <div style={{ animation: "fadeIn .2s ease" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
              <button onClick={() => setShowPicker(true)} style={{ padding: 14, borderRadius: 14, border: "none", background: C.primary, color: "#fff", fontWeight: 700, fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                <Ico d={IC.contact} size={17} color="#fff" /> Pick Contacts
              </button>
              <button onClick={addAll} style={{ padding: 14, borderRadius: 14, border: `1.5px solid ${C.primary}`, background: C.primaryLight, color: C.primary, fontWeight: 700, fontSize: 14 }}>
                + All ({customers.length})
              </button>
            </div>

            {recipients.length > 0 ? (
              <div style={{ background: "#fff", borderRadius: 18, padding: 16, marginBottom: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: C.text }}>{recipients.length} Recipient{recipients.length > 1 ? "s" : ""}</div>
                  <button onClick={() => setRecipients([])} style={{ fontSize: 12, color: "#E11D48", background: "#FFF1F2", border: "none", borderRadius: 8, padding: "4px 10px", fontWeight: 700 }}>Clear</button>
                </div>
                {recipients.map((c, i) => (
                  <div key={c.phone} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: i < recipients.length - 1 ? `1px solid ${C.border}` : "none" }}>
                    <Avatar name={c.name} size={36} idx={i} />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, fontSize: 14, color: C.text }}>{c.name}</div>
                      <div style={{ fontSize: 12, color: C.sub }}>{c.phone}</div>
                    </div>
                    <button onClick={() => remove(c.phone)} style={{ background: "#FFF1F2", border: "none", borderRadius: 8, width: 30, height: 30, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Ico d={IC.close} size={14} color="#E11D48" />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: "center", padding: "36px 20px", color: C.sub, background: "#fff", borderRadius: 18, marginBottom: 16 }}>
                <div style={{ fontSize: 40, marginBottom: 8 }}>👥</div>
                <div style={{ fontWeight: 600, fontSize: 15 }}>No recipients yet</div>
                <div style={{ fontSize: 13, marginTop: 4 }}>Pick from contacts or add all customers</div>
              </div>
            )}

            <button onClick={() => recipients.length > 0 ? setStep(3) : showToast("Add at least one recipient")}
              style={{ width: "100%", padding: 16, borderRadius: 16, border: "none", background: C.primary, color: "#fff", fontWeight: 800, fontSize: 16 }}>
              Next: Preview & Send →
            </button>
          </div>
        )}

        {/* Step 3 */}
        {step === 3 && (
          <div style={{ animation: "fadeIn .2s ease" }}>
            <div style={{ background: "#0F172A", borderRadius: 18, padding: 20, marginBottom: 16 }}>
              <div style={{ color: "#F59E0B", fontWeight: 700, fontSize: 13, marginBottom: 10 }}>
                {msgType === "whatsapp" ? "💬 WhatsApp Preview" : "📱 SMS Preview"}
              </div>
              <div style={{ background: "rgba(255,255,255,0.08)", borderRadius: 12, padding: 14, fontSize: 13, color: "#E2E8F0", lineHeight: 1.8, whiteSpace: "pre-wrap" }}>{msg}</div>
            </div>
            <div style={{ background: "#fff", borderRadius: 18, padding: 18, marginBottom: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 6 }}>Send Summary</div>
              <div style={{ fontSize: 14, color: C.sub, lineHeight: 2.2 }}>
                📨 Via: <b style={{ color: msgType === "whatsapp" ? C.wa : "#0369A1" }}>{msgType === "whatsapp" ? "WhatsApp" : "SMS"}</b><br/>
                👥 To: <b style={{ color: C.text }}>{recipients.length} customer{recipients.length > 1 ? "s" : ""}</b><br/>
                📝 Length: <b style={{ color: C.text }}>{msg.length} characters</b>
              </div>
            </div>
            <button onClick={send} style={{ width: "100%", padding: 18, borderRadius: 16, border: "none", background: msgType === "whatsapp" ? C.wa : C.primary, color: "#fff", fontWeight: 900, fontSize: 17, boxShadow: `0 4px 20px ${msgType === "whatsapp" ? "rgba(37,211,102,0.4)" : "rgba(29,78,216,0.4)"}`, display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
              <Ico d={IC.send} size={20} color="#fff" />
              Send {msgType === "whatsapp" ? "WhatsApp" : "SMS"} to {recipients.length} People
            </button>
          </div>
        )}

        {/* Sent log */}
        {log.length > 0 && (
          <div style={{ marginTop: 24 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: C.text, marginBottom: 10 }}>📤 Sent History</div>
            {log.map(l => (
              <div key={l.id} style={{ background: "#fff", borderRadius: 14, padding: "14px 16px", marginBottom: 8, display: "flex", gap: 12, alignItems: "center", boxShadow: "0 2px 6px rgba(0,0,0,0.05)" }}>
                <div style={{ width: 42, height: 42, borderRadius: 12, background: l.type === "whatsapp" ? C.waLight : "#F0F9FF", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>
                  {l.type === "whatsapp" ? "💬" : "📱"}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, color: C.green }}>✓ {l.count} customer{l.count > 1 ? "s" : ""}</div>
                  <div style={{ fontSize: 12, color: C.sub }}>{l.preview}…</div>
                </div>
                <div style={{ fontSize: 11, color: C.sub }}>{l.time}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showPicker && <ContactPicker onSelect={addPicked} onClose={() => setShowPicker(false)} multi preSelected={recipients} />}
    </div>
  );
}
